import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const imageV3PaddingToMarginMigration: PropsMigration = {
  mode: 'props',
  description: 'Migrate image external spacing from offset.padding to offset.margin',
  run: (props: PartialPropsOf<'image'>): void => {
    const offset = props.style?.image?.offset;
    if (offset?.padding === undefined) {
      return;
    }
    offset.margin = offset.padding;
    delete offset.padding;
  },
};
